import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-32c1832e")

_pushScopeId("data-v-32c1832e")
const _hoisted_1 = { class: "p-grid" }
const _hoisted_2 = { class: "p-col-6 p-col-sm-12" }
const _hoisted_3 = { class: "p-d-flex p-ai-center p-p-2" }
const _hoisted_4 = { class: "title p-mb-0 p-mr-2" }
const _hoisted_5 = { class: "p-text-bold" }
const _hoisted_6 = { class: "p-d-flex p-ai-center p-p-2" }
const _hoisted_7 = { class: "title p-mb-0 p-mr-2" }
const _hoisted_8 = { class: "p-d-flex p-ai-center p-p-2" }
const _hoisted_9 = { class: "title p-mb-0 p-mr-2" }
const _hoisted_10 = { class: "p-d-flex p-ai-center p-p-2" }
const _hoisted_11 = { class: "title p-mb-0 p-mr-2" }
const _hoisted_12 = { class: "p-text-bold" }
const _hoisted_13 = { class: "p-d-flex p-ai-center p-p-2" }
const _hoisted_14 = { class: "title p-mb-0 p-mr-2" }
const _hoisted_15 = { class: "p-text-bold" }
const _hoisted_16 = { class: "p-d-flex p-ai-center p-p-2" }
const _hoisted_17 = { class: "title p-mb-0 p-mr-2" }
const _hoisted_18 = { class: "p-text-bold" }
const _hoisted_19 = { class: "p-d-flex p-ai-center p-p-2" }
const _hoisted_20 = { class: "title p-mb-0 p-mr-2" }
const _hoisted_21 = { class: "p-text-bold" }
const _hoisted_22 = { class: "p-d-flex p-ai-center p-p-2" }
const _hoisted_23 = { class: "title p-mb-0 p-mr-2" }
const _hoisted_24 = { class: "p-text-bold" }
const _hoisted_25 = { class: "p-col-6 p-col-sm-12" }
const _hoisted_26 = { class: "p-d-flex p-ai-center p-p-2" }
const _hoisted_27 = { class: "title p-mb-0 p-mr-2" }
const _hoisted_28 = { class: "p-d-flex p-ai-center p-p-2" }
const _hoisted_29 = { class: "title p-mb-0 p-mr-2" }
const _hoisted_30 = { class: "p-d-flex p-ai-center p-p-2" }
const _hoisted_31 = { class: "title p-mb-0 p-mr-2" }
const _hoisted_32 = { class: "p-d-flex p-ai-center p-p-2" }
const _hoisted_33 = { class: "title p-mb-0 p-mr-2" }
const _hoisted_34 = /*#__PURE__*/_createVNode("p", { class: "p-text-bold" }, null, -1)
const _hoisted_35 = {
  key: 0,
  class: "p-d-flex p-ai-center p-p-2"
}
const _hoisted_36 = { class: "title p-mb-0 p-mr-2" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Tag = _resolveComponent("Tag")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_Chip = _resolveComponent("Chip")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("h5", null, _toDisplayString(_ctx.$t("autots.metadata.label.metadata")), 1),
      _createVNode("div", _hoisted_3, [
        _createVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("autots.label.name")) + ":", 1),
        _createVNode("p", _hoisted_5, _toDisplayString(_ctx.experimentDetail.name), 1)
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("autots.label.status")) + ":", 1),
        _createVNode(_component_Tag, {
          severity: _ctx.getStatusStyle(_ctx.experimentDetail.status)
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.experimentDetail.status), 1)
          ]),
          _: 1
        }, 8, ["severity"])
      ]),
      _createVNode("div", _hoisted_8, [
        _createVNode("p", _hoisted_9, _toDisplayString(_ctx.$t("autots.label.cost")) + ":", 1),
        _createVNode("mark", null, _toDisplayString(new Intl.NumberFormat("en-IN", {
              style: "currency",
              currency: _ctx.experimentDetail.currency,
              maximumFractionDigits: 4,
            }).format(_ctx.experimentDetail.cost)), 1)
      ]),
      _createVNode("div", _hoisted_10, [
        _createVNode("p", _hoisted_11, _toDisplayString(_ctx.$t("autots.label.createdby")) + ":", 1),
        _createVNode("p", _hoisted_12, _toDisplayString(_ctx.getFullname(_ctx.experimentDetail.createdBy)), 1)
      ]),
      _createVNode(_component_Divider),
      _createVNode("h5", null, _toDisplayString(_ctx.$t("autots.metadata.label.configuration")), 1),
      _createVNode("div", _hoisted_13, [
        _createVNode("p", _hoisted_14, _toDisplayString(_ctx.$t("autots.label.predictduration")) + ": ", 1),
        _createVNode("p", _hoisted_15, _toDisplayString(_ctx.experimentDetail.config.forecastHorizon), 1)
      ]),
      _createVNode("div", _hoisted_16, [
        _createVNode("p", _hoisted_17, _toDisplayString(_ctx.$t("autots.metadata.label.training_start_date")) + ": ", 1),
        _createVNode("p", _hoisted_18, _toDisplayString(_ctx.$moment(_ctx.experimentDetail.config.startDate).format("YYYY-MM-DD")), 1)
      ]),
      _createVNode("div", _hoisted_19, [
        _createVNode("p", _hoisted_20, _toDisplayString(_ctx.$t("autots.metadata.label.training_end_date")) + ": ", 1),
        _createVNode("p", _hoisted_21, _toDisplayString(_ctx.$moment(_ctx.experimentDetail.config.splitDate).format("YYYY-MM-DD")), 1)
      ]),
      _createVNode("div", _hoisted_22, [
        _createVNode("p", _hoisted_23, _toDisplayString(_ctx.$t("autots.metadata.label.test_end_date")) + ": ", 1),
        _createVNode("p", _hoisted_24, _toDisplayString(_ctx.$moment(_ctx.experimentDetail.config.endDate).format("YYYY-MM-DD")), 1)
      ])
    ]),
    _createVNode("div", _hoisted_25, [
      _createVNode("h5", null, _toDisplayString(_ctx.$t("autots.metadata.label.datasource")), 1),
      _createVNode("div", _hoisted_26, [
        _createVNode("p", _hoisted_27, _toDisplayString(_ctx.$t("autots.label.name")) + ":", 1),
        (_ctx.datasourceDetail)
          ? (_openBlock(), _createBlock("a", {
              key: 0,
              target: "_blank",
              href: `/workspace/${_ctx.workspaceId}/datasource/${_ctx.datasourceDetail.id}/`
            }, _toDisplayString(_ctx.datasourceDetail.name), 9, ["href"]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_28, [
        _createVNode("p", _hoisted_29, _toDisplayString(_ctx.$t("autots.label.targetcolumn")) + ": ", 1),
        (_ctx.datasourceConfig && _ctx.datasourceConfig[0])
          ? (_openBlock(), _createBlock(_component_Chip, {
              key: 0,
              label: _ctx.datasourceConfig[0].targetColumn
            }, null, 8, ["label"]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_30, [
        _createVNode("p", _hoisted_31, _toDisplayString(_ctx.$t("autots.label.timeseriescolumn")) + ": ", 1),
        (_ctx.datasourceConfig && _ctx.datasourceConfig[0])
          ? (_openBlock(), _createBlock(_component_Chip, {
              key: 0,
              label: _ctx.datasourceConfig[0].timeSeriesColumn
            }, null, 8, ["label"]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_32, [
        _createVNode("p", _hoisted_33, _toDisplayString(_ctx.$t("autots.label.time.column.format")) + ": ", 1),
        _hoisted_34
      ]),
      (_ctx.datasourceConfig && _ctx.datasourceConfig[0])
        ? (_openBlock(), _createBlock("div", _hoisted_35, [
            _createVNode("p", _hoisted_36, _toDisplayString(_ctx.$t("autots.label.IDCs")) + ":", 1),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.datasourceConfig[0].timeSeriesIdentifiers, (column, index) => {
              return (_openBlock(), _createBlock(_component_Chip, {
                key: index,
                label: column,
                class: "p-mr-2"
              }, null, 8, ["label"]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
})